import React, { Component } from "react";
import PropTypes from 'prop-types';
import { Spinner } from 'react-bootstrap';

class Loading extends Component {
  static propTypes = {
    children: PropTypes.any
  };

  constructor() {
    super();

    this.state = {
      title: '',
      forcesResult: null,
    };
    this.loaderRef = null;
  }

  componentDidMount() {
    if (!this.loaderRef) {
      return ;
    }
    this.loaderRef.forceResult = (component) => {
      this.setState({
        forcedResult: component,
      });
    };
  }

  render() {
    const content = (this.state.forcedResult) ? this.state.forcedResult
      : (
        <>
          <Spinner
            as="span"
            animation="grow"
            size="sm"
            role="status"
            aria-hidden="true"
          />
          {"\t"}{this.props.children || 'Loading...'}
        </>
      );

    return (
      <div className="contentLoding" ref={ref => this.loaderRef = ref}>
        {content}
      </div>
    );
  }
}

export default Loading;
